import React, {useState, Fragment, useEffect} from 'react';
import AutoFill from "../../../../../models/AutoFill";
import { getTitleTable, getDataSource, columnsTable, genaratePaginateFilterSort, checkUndefine, formatValidation } from "../../../../../helpers/functions";
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import { useTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import { Link } from 'react-router-dom';
import Ripple from '../../../common/component/Ripple';
import { Icon } from 'antd';
import DEFINE, { DATE_TIME_FORMAT, PATHS, AUTOFILL_ENUM } from '../../../../../constants/Define';
import moment from "moment";

const ListCols = [
    'campaignName',
    'promotionCode',
    'startDate',
    'dayOfWeek',
    'memberShipTypes',
    'productTypes',
    'order',
    'isActive',
];
let permissionActions = [];

const ModelFields = Object.getOwnPropertyNames(new AutoFill());

const AutoFillList = ({...props}) => {

    const { autoFills, pagination, loading, getListAutoFill } = props;
    const { t } = useTranslation();

    const [titleItemTable, setTitleItemTable] = useState(getTitleTable(ListCols, ['action'], []),);
    const [modelItem, setModelItem] = useState(ModelFields);
    const [dataFilter, setDataFilter] = useState({
        filters: {
            pageSize: pagination.pageSize,
            pageIndex: pagination.pageIndex,
        },
    })
    const [componentTable, setComponentTable] = useState(
        {
            campaignCode: {
                key: 'campaignCode',
                render: (text, record) => text,
            },
            startDate: {
                key: 'startDate',
                render: (startDate, record) => {
                    return(
                        <span>{startDate && moment(startDate).format(DATE_TIME_FORMAT.SHORT_DATE)}
                         { record?.endDate && ` - ${moment(record?.endDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                        </span>
                    )
                }
            },
            dayOfWeek: {
                key: 'dayOfWeek',
                render: dayOfWeek => dayOfWeek &&
                Object.keys(dayOfWeek).length > 0 && (Object.keys(dayOfWeek).length === 7 ?
                t(`item.ticket.allDay`) : (Object.keys(dayOfWeek) || []).map((dayKey)=>{
                    return t(`item.ticket.${ dayKey }`) ;
                }).join(', '))
            },
            memberShipTypes: {
                key: 'memberShipTypes',
                render: (memberShipTypes) => memberShipTypes && memberShipTypes.length > 0 &&
                memberShipTypes.map((item, idx)=>{
                    let itemType = item;
                    if(typeof item === 'number'){
                        switch(item){
                            case 5:
                                itemType = 'PEARL_CLUB';
                                break;
                            case 6:
                                itemType = 'NON';
                                break;
                            case 7:
                                itemType = 'PEARL';
                                break;
                            case 8:
                                itemType = 'AMBASSADOR_PEARL';
                                break;
                            default:
                                break;
                        }
                    }
                    return `${AUTOFILL_ENUM.MEMBER_SHIP_TYPE[itemType]?.label || item}${idx < (memberShipTypes.length - 1) ? ', ' : ''}`;
                })
            },
            productTypes: {
                key: 'productTypes',
                render: productTypes => productTypes && (productTypes || []).map((item, idx)=>{
                    let itemType = AUTOFILL_ENUM.PRODUCTYPES[item]?.label;
                    return `${itemType}${idx < (productTypes.length - 1) ? ', ' : ''}`;
                })
            },
            isActive: {
                key: 'isActive',
                render: (text, record) => (
                    <StatusComponent color={ text ? 'green' : 'red' } label={ text ? t('item.bundle.activated') : t('item.bundle.deactivated') }/>
                ),
            },
            action: {
                width: 100,
                align: 'center',
                key: 'action',
                render: (text, record) => renderEditComponent(record)
            }
        }
    );

    useEffect(()=>{
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.AUTO_FILL);
    });

    const renderEditComponent = (item)=> {
        return (
            <Fragment>
                {
                    permissionActions && permissionActions.allowUpdate &&
                    <Link to={Func.getPathWithParams(PATHS.AUTOFILL.DETAIL.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                        <Ripple><Icon type="form" className="fs20" /></Ripple>
                    </Link>
                }
            </Fragment>
        )
    }

    const onTableChange = (pagination, filters, sorter) => {
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        setDataFilter({ filters: newFilters });
        getListAutoFill(newFilters);
    }

    const onColumnVisibleChange = (column, isVisibled) => {
        const currentComponentTable = componentTable;
        currentComponentTable[column.dataIndex].visible = isVisibled;
        setComponentTable(currentComponentTable);
    }

    return(
        <Fragment>
            <ListComponent
                tableKey="autoFill-list"
                classChildren="p-0" classParent="m-0"
                rowKey={ (record, k) => record.id ? record.id : k }
                loading={ { spinning: loading, size: 'large' } }
                dataSource={ getDataSource(autoFills || [], modelItem) }
                columns={ columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'autoFill'
                }) }
                onChange={ onTableChange }
                componentTableList={ {} }
                onColumnVisibleChange={ onColumnVisibleChange }
                pagination={ { total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize } }
            >
            </ListComponent>
        </Fragment>
    )
}

export default AutoFillList;
